module.exports = __webpack_public_path__ + "static/media/x86kernel.3faca725.png";